<nz-modal
  [nzVisible]="true"
  nzWidth="600px"
  nzTitle="Email Status History"
  [nzFooter]="null"
  (nzOnCancel)="onCancel()">
  <ng-container *nzModalContent>

    @if (processedStatuses().length > 0) {
      <div  class="all-button">
        <div class="button" (click)="onShowAll()">
          @if (showAllEmails()) {
            Last email
          } @else {
            All emails
          }
        </div>
      </div>
      @if (showAllEmails()) {
        <nz-table #basicTable [nzData]="allEmails()" [nzScroll]="{ y: '400px' }" [nzFrontPagination]="false">
          <thead>
          <tr>
            <th nzWidth="200px">Subject</th>
            <th>Last Status</th>
            <th>Last Update</th>
            <th>Operation</th>
          </tr>
          </thead>
          <tbody>
            @for (data of basicTable.data; track $index) {
              <tr>
                <td>{{ data.subject }}</td>
                <td> {{ getStatusTitle(data.lastStatus) }}</td>
                <td>{{ data.lastStatusUpdatedAt  | date }}</td>
                <td>
                  <a (click)="onSelectEmail(data)">History</a>
                </td>
              </tr>
            }

          </tbody>
        </nz-table>
      } @else {
        <div class="status-timeline">
          @for (status of processedStatuses(); track status) {
            <div class="status-item">
              <div class="status-icon-wrapper">
                <div class="status-icon" [ngClass]="getStatusClass(status.status)">
                  <i nz-icon [nzType]="getIconType(status.status)" nzTheme="outline"></i>
                </div>
              </div>
              <div class="status-content">
                <div class="status-header">
            <span class="status-title" [ngClass]="getStatusClass(status.status)">
              {{ getStatusTitle(status.status) }}
            </span>
                  <span class="status-time">{{ status.timestamp | date:'medium' }}</span>
                </div>

                <!-- Sent Status Details (Initial Send) -->
                @if (status.isInitialSent) {
                  <div class="status-details">
                    <div class="detail-row">
                      <span class="detail-label">To:</span>
                      <span class="detail-value">{{ status.to }}</span>
                    </div>
                    @if (status.cc && status.cc.length > 0) {
                      <div class="detail-row">
                        <span class="detail-label">CC:</span>
                        <span class="detail-value">
                <ng-container *ngFor="let email of status.cc; let i = index; let last = last">
                  {{ email }}<span *ngIf="!last">, </span>
                </ng-container>
              </span>
                      </div>
                    }

                    @if (status.bcc && status.bcc.length > 0) {
                      <div class="detail-row">
                        <span class="detail-label">BCC:</span>
                        <span class="detail-value">
                <ng-container *ngFor="let email of status.bcc; let i = index; let last = last">
                  {{ email }}<span *ngIf="!last">, </span>
                </ng-container>
              </span>
                      </div>
                    }

                    <button type="button" nz-button nzType="default" class="view-button" (click)="onViewEmail()">
                      <i nz-icon nzType="eye" nzTheme="outline"></i>
                    </button>
                  </div>
                }

                @if (!status.isInitialSent && status.status !== TransactionEmailStatus.FAILED) {
                  <!-- Delivered/Opened Status Details -->
                  <div class="status-details">
                    <div class="detail-row">
                      <span class="detail-label">Recipients ({{ status.emailAddresses.length }}):</span>
                      <span class="detail-value">
                <ng-container *ngFor="let email of status.emailAddresses; let i = index; let last = last">
                  {{ email }}<span *ngIf="!last">, </span>
                </ng-container>
              </span>
                    </div>
                  </div>
                }


                @if (status.status === TransactionEmailStatus.FAILED) {
                  <div class="status-details failed-details">
                    <div class="detail-row">
                      <span class="detail-label">Recipients ({{ status.emailAddresses.length }}):</span>
                      <span class="detail-value">
                <ng-container *ngFor="let email of status.emailAddresses; let i = index; let last = last">
                  {{ email }}<span *ngIf="!last">, </span>
                </ng-container>
              </span>
                    </div>
                    <div class="failure-badge">
                      Failure: Delivery failed
                    </div>
                    <button type="button" nz-button nzType="primary" class="resend-button" (click)="onResendEmail()">
                      Resend Email
                    </button>
                  </div>
                }
                <!-- Failed Status Details -->

              </div>
            </div>
          }

        </div>
      }
    }

    @if (processedStatuses().length === 0 && !loading()) {
      <!-- Empty State -->
      <div class="empty-state">
        <p>No email history available</p>
      </div>
    }

    @if (loading()) {
      <div class="empty-state">
        <nz-spin nzSimple></nz-spin>
      </div>
    }
  </ng-container>
</nz-modal>

@if (showSendEmailModal()) {
  <app-send-email (close)="onCloseSendEmail()" [readonly]="readonlyMode()"
                  [docType]="docType()"
                  [docCode]="docCode()"
                  [emailHistoryDetail]="emailHistoryDetail()"
                  [senderTransactionType]="senderTransactionType()"
                  [customReportType]="customReportType()"
                  [transactionId]="id()" />
}
